import { IsArray, IsUUID } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

/**
 * DTO pour la validation atomique d'une assignation teaching
 * Envoyé à School pour valider tous les critères en une seule passe
 */
export class ValidateUserAssignmentRequestDto {
  @ApiProperty({
    type: 'string',
    description: "UUID de l'utilisateur (enseignant)",
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsUUID()
  userId!: string

  @ApiProperty({
    type: 'string',
    description: "UUID de l'activité",
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsUUID()
  activityId!: string

  @ApiProperty({
    type: [String],
    description: 'UUIDs des leçons',
    example: ['550e8400-e29b-41d4-a716-446655440001'],
  })
  @IsArray()
  @IsUUID('4', { each: true })
  lessonIds!: string[]
}

/**
 * Contexte user assignment retourné par School pour dénormalisation
 */
export interface UserAssignmentContext {
  id: string
  activityId: string
  userId: string
  schoolYearCode: string
}

/**
 * Réponse de validation atomique retournée par School
 */
export interface ValidationUserAssignmentError {
  code: ValidationUserAssignmentErrorCode
  message: string
  lessonId?: string
  field?: string
}

export enum ValidationUserAssignmentErrorCode {
  NOT_STAFF = 'NOT_STAFF',
  STAFF_PERIOD_INVALID = 'STAFF_PERIOD_INVALID',
  TEACHING_NOT_FOUND = 'TEACHING_NOT_FOUND',
  TEACHING_DELETED = 'TEACHING_DELETED',
  TEACHING_INACTIVE = 'TEACHING_INACTIVE',
  INVALID_LESSON = 'INVALID_LESSON',
  LESSON_NOT_IN_TEACHING = 'LESSON_NOT_IN_TEACHING',
  LESSON_DELETED = 'LESSON_DELETED',
  SCHOOL_YEAR_INACTIVE = 'SCHOOL_YEAR_INACTIVE',
  SCHOOL_YEAR_ARCHIVED = 'SCHOOL_YEAR_ARCHIVED',
  SCHOOL_YEAR_NOT_STARTED = 'SCHOOL_YEAR_NOT_STARTED',
  SUBJECT_MISMATCH = 'SUBJECT_MISMATCH',
  LEVEL_MISMATCH = 'LEVEL_MISMATCH',
  ESTABLISHMENT_MISMATCH = 'ESTABLISHMENT_MISMATCH',
  USER_NOT_IN_CLASS = 'USER_NOT_IN_CLASS',
  USER_NOT_IN_GROUP = 'USER_NOT_IN_GROUP',
}

export class ValidateUserAssignmentResponseDto {
  @ApiProperty({
    type: Boolean,
    description: "Indique si l'assignation peut être effectuée",
    example: true,
  })
  canAssign!: boolean

  @ApiProperty({
    type: [Object],
    description: 'Liste des erreurs de validation',
    example: [],
  })
  errors!: ValidationUserAssignmentError[]

  @ApiPropertyOptional({
    type: Object,
    description: 'Contexte user assignment si validation réussie',
  })
  userAssignment?: UserAssignmentContext
}
